"use client";

import posthog from "posthog-js";
import { useEffect } from "react";

import { useAudience } from "@/components/common/audience";

type DataLayerWindow = Window & { dataLayer?: unknown[] };

export function AudienceDataLayer(): null {
  const { activeTab } = useAudience();

  useEffect(() => {
    const audience = activeTab === "businesses" ? "b2b" : "b2c";

    const target = window as DataLayerWindow;
    target.dataLayer = target.dataLayer ?? [];
    target.dataLayer.push({ audience });

    posthog.register({ audience });
  }, [activeTab]);

  return null;
}
